import React, { useState } from "react"
import Button from "@material-ui/core/Button"
import { login } from "../../redux/apiCalls"
import "./login.css"
import { useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import { renderLoginErrorMsg } from "../../services/errorsForm"

const Login = () => {
  const [email, setEmail] = useState()
  const [password, setPassword] = useState()
  const dispatch = useDispatch()
  const [formErrorMsg, setFormErrorMsg] = useState()

  const onLogin = () => {
    login(dispatch, { email, password }, setFormErrorMsg)
  }

  return (
    <div className='login__background'>
      <form className='login__form'>
        <h1 className='login__title'>Login</h1>
        <p>Email: demo@gmail.com</p>
        <p>Password: demopassword</p>
        <input
          placeholder='Email'
          onChange={(e) => {
            setEmail(e.target.value)
          }}
          type='text'
          className='login__input'
        />
        {renderLoginErrorMsg(formErrorMsg)}
        <input
          placeholder='Password'
          onChange={(e) => {
            setPassword(e.target.value)
          }}
          type='password'
          className='login__input'
        />
        {renderLoginErrorMsg(formErrorMsg)}
        <Button variant='contained' onClick={onLogin} className='login__btn'>
          Log In
        </Button>
        <p className='link__register'>
          Don't have an account? <Link to='/register'>Sign up</Link>
        </p>
      </form>
    </div>
  )
}

export default Login
